export const environment = {
  production: false,
  // apiUrl: '',
  apiUrl: 'https://api.dancehub.space/api/v1.0',
  hubUrl: 'https://localhost:5001/hub/notifications',
  stripePublicKey:
    'pk_test_51PeXuWHV9KPhYMymy0FJpQRoP5sPhsN3CmZwIrUcDf9l46nOKFHkqefnDp3nRiBWA0PLkzNvfpvVTCaikCk6V3yH008P5RbZDa',
  settings: {
    auth: {
      // OAuth2 credentials
      clientId: 'fake-client-id', // <Your auth client id here>
      secretId: 'fake-secret-id', // <Your auth secret id here>

      // keys to store tokens at local storage
      accessTokenKey: 'DoPS3ZrQjM',
      refreshTokenKey: 'nmlP8PW2nb',
    },
    general: {
      maxBirthDate: 6,
    },
    whatsapp: {
      phone: '79779861110',
      message: 'Здравствуйте! Я хочу подтвердить свой профиль для создания мероприятий\n\n',
    },
  },
};
